module.exports = function (locale, preview, filters) {
  return `{
      productCollection(limit: 1, locale: "${locale}", preview: ${preview}, where: {slug: "${filters.slug}", sys: {id: "${filters.contentfulId}" }}) {
         items {
          productName
          slug
          topBanner {
            __typename
            ... on TopHomepageBanner{
              banner {
                        image {
                            desktopImage{
                              url
                            }
                          smartphoneImage{
                            url
                          }
                          altText
                        }
                        }
                        topTextTitle
                        topTextOnePercentage
                        titleTextOne
                        bottomTextOnePercentage
                        textTwoTitle
                        footerText
            }
            ... on ProductBanners {
              name
              title
              bannerTitle
              category
              topText
              percentageText
              discoverNewText
              disclaimerText
              styles
              bannerImage {
                image {
      __typename
      name
      altText
      styles
      desktopImage {
        url
      }
      tabletImage {
        url
      }
      smartphoneImage {
        url
      }
                }
              }
            }
          }

          simpleBanner {
            __typename  
            ... on IconImageCollection{
              footerText
              imageListCollection(limit:12){
                items{
                  description
                  title
                  iconImageSet{
                    altText
                    componentWidth{
                      desktopComponentWidth
                      smartphoneComponentWidth
                      name
                    }
                    desktopImage{
                      url}
                  }
                }
              }
              bannerImage{
                altText
                desktopImage{
                  url
                }
                componentWidth{
                  desktopComponentWidth
                  smartphoneComponentWidth
                }
                name
                smartphoneImage{
                  url
                }
                tabletImage{
                  url
                }
                styles
                tooltip
              }
            }
            ... on ProductBanners {
              name
              title
              bannerTitle
              category
              topText
              percentageText
              discoverNewText
              disclaimerText
              styles
              bannerImage {
                image {
      __typename
      name
      altText
      styles
      desktopImage {
        url
      }
      tabletImage {
        url
      }
      smartphoneImage {
        url
      }
                }
              }
            }
          }

          middleBannerSection {
            __typename
            ... on HomepageMiddleBannerSection{
              title
                        subtitle
                        footerText
                        bannerImage {

        altText
        desktopImage {
            url
        }
        smartphoneImage {
            url
        }
        componentWidth {
            ... on ComponentWidth {
        name
        desktopComponentWidth
        smartphoneComponentWidth
        tabletComponentWidth
            }
        }
        styles
                        }
                        
                        collectionListCollection(limit:8) {
                        items {
                            title
                            description
                            iconImageSet {
        __typename
        name
        altText
        desktopImage {
            url
        }
        tabletImage {
            url
        }
        smartphoneImage {
            url
        }
        componentWidth {
            ... on ComponentWidth {
                sys {
            id
        }
        name
        desktopComponentWidth
        smartphoneComponentWidth
        tabletComponentWidth
            }
        }
        styles
                            }
                        }
                        }
            }
            ... on ProductBanners {
              title
              bannerTitle
              category
              topText
              percentageText
              discoverNewText
              disclaimerText
              styles
              bannerImage {
                image {
      __typename
      name
      altText
      styles
      desktopImage {
        url
      }
      tabletImage {
        url
      }
      smartphoneImage {
        url
      }
                }
              }
            }
          }

          bottomBanner {
            __typename
            ... on BottomHomepageBanner{
               title
                        footerText
                        imageListCollection(limit: 2) {
                        items {
                            name
                            text
                            imageSet {
                                
        altText
        desktopImage {
            url
        }
        tabletImage {
            url
        }
        smartphoneImage {
            url
        }
        styles
                            }
                        }
                        }
            }
            ... on ProductBanners {
              title
              bannerTitle
              category
              topText
              percentageText
              discoverNewText
              disclaimerText
              styles
              hairTypeLevel1
              hairTypeLevel2
              bannerImage {
                image {
      __typename
      name
      altText
      styles
      desktopImage {
        url
      }
      tabletImage {
        url
      }
      smartphoneImage {
        url
      }

                }
              }
            }
          }

          ratingReviewSection {
            __typename
            ... on RatingReviewBanner{
               title
                        subtitle
                        bannerImage {
                        desktopImage { url }
                        smartphoneImage { url }
                        altText
                        }
                        brandSuccessTextCollection(limit: 2) {
                        items {
                            name
                            body
                        }
                        }
                        footerTest
                        ratingTitle
                        comment
                        username
                        ratingNumber
            }
            ... on ProductBanners {
              title
              bannerTitle
              category
              topText
              percentageText
              discoverNewText
              disclaimerText
               productListCollection(limit:5) {
          items {
            ... on BannerProductsList {
              productName
              category
              styles
            }
          }
        }
              styles
              bannerImage {
                image {
      __typename
      name
      altText
      styles
                  desktopImage {
        url
      }
      tabletImage {
        url
      }
      smartphoneImage {
        url
      }
            }
          }
        }
      

                }
              }
      }
    }
  `;
};
